/**
 * Redirects page to given (relative) url.
 *
 * N.b. uses native browser redirect (as opposed to Vue router).
 *
 * Args:
 *      relativeUrl (String): Relative url path.
 *
 * Returns:
 *      (Undefined): Redirects page.
 *
 * Example:
 *      redirect('/'); // redirects to home page
 */
export function redirect(relativeUrl) {
    if (!relativeUrl) return;

    window.location.href = `${ window.location.protocol }//${ window.location.host }${ relativeUrl }`;
}

export function getJsonFromQueryString(qs) {
    if (!qs) return {};

    if (qs.startsWith('?') || qs.startsWith('&')) {
        qs = qs.substring(1);
    }

    return JSON.parse(`{"${ decodeURI(qs).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') }"}`);
}
